// src/components/TermsConditions.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFileContract } from 'react-icons/fa';

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Link 
        to="/" 
        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
      >
        <FaArrowLeft /> Back to Home
      </Link>

      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <FaFileContract className="text-2xl text-green-600" />
          <h1 className="text-3xl font-bold text-gray-800">Terms & Conditions</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Effective date: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700">
              By accessing and using FreshMart Groceries, you accept and agree to be bound by 
              these Terms and Conditions. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Ordering and Payment</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>All orders are subject to product availability</li>
              <li>Prices are subject to change without notice</li>
              <li>We accept various payment methods including credit cards, UPI, and cash on delivery</li>
              <li>Orders are confirmed only after payment verification</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Delivery</h2>
            <p className="text-gray-700 mb-4">We deliver to the address provided during checkout. Delivery times are estimates and may vary based on:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Product availability</li>
              <li>Delivery location</li>
              <li>Weather conditions</li>
              <li>Unexpected events</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. User Accounts</h2>
            <p className="text-gray-700">
              You are responsible for maintaining the confidentiality of your account information 
              and for all activities that occur under your account.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;